import React from "react";
import { useTranslation } from "react-i18next";
import { Folder, folder as folderMock, Identifiable } from "@planzone/dto";
import { useCreateFolder } from "@planzone/view-models";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { Props } from "./types";
import { Form } from "./form";
import styles from "./styles.scss";

function FolderCreation({
  namespace,
  type,
  rootName = "",
  parentFolder: initialParentFolder,
  cancel,
}: Props) {
  const { t } = useTranslation();
  const { isRequestPending, createFolder } = useCreateFolder();
  const [folder, setFolder] = React.useState<Folder>(folderMock);
  const [parentFolder, setParentFolder] =
    React.useState<Identifiable<Folder> | null>(initialParentFolder);

  return (
    <Modal header={t("folderCreation.title")} close={cancel}>
      <form
        className={styles.main}
        onSubmit={(e) => {
          e.preventDefault();

          !isRequestPending &&
            parentFolder &&
            createFolder({
              namespace,
              type,
              folder,
              parentFolder,
            });
        }}
      >
        <div className={styles.form}>
          <Form
            namespace={namespace}
            type={type}
            formData={folder}
            parentFolder={parentFolder}
            rootName={rootName}
            selectParentFolder={setParentFolder}
            edit={setFolder}
          />
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("folderCreation.cancel")}
          </Button>
          <Button
            type="submit"
            status={isRequestPending ? "pending" : "none"}
            isDisabled={isRequestPending}
          >
            {t("folderCreation.submit")}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export { FolderCreation };
